const menuList = [
  { path: '/index', title: '酒店管理', icon: 'home', showHead: true },
  { path: '/staff', title: '员工管理', icon: 'user', showHead: true },
  { path: '/agents', title: '代理商管理', icon: 'users', showHead: true, checkShow: true },
  { path: '/product', title: '产品功能管理', icon: 'codepen' },
  {
    title: '程序管理',
    icon: 'codepen',
    children: [
      { path: '/codes/page1', title: '草稿管理', icon: 'code' },
      { path: '/codes/page2', title: '模板管理', icon: 'code' }
    ],
    checkShow: true
  },
  { path: '/feedbacks', title: '客户反馈', icon: 'comments', checkShow: true },
  { path: '/report', title: '统计报表', icon: 'line-chart', checkShow: true },
  { path: '/analytics', title: '业绩报表', icon: 'bar-chart', checkShow: true },
  { path: '/logs', title: '日志管理', icon: 'file' },
  { path: '/super-logs', title: '服务器日志', icon: 'file-o', checkShow: true },
  { path: '/setting', title: '高级设置', icon: 'cog', showHead: true }
];

export const menuHeader = menuList.filter(item => {
  return item.showHead;
});

export const menuAside = menuList;
